/* eslint-disable */
import $ from 'jquery'
import postToInspectRealEstate from './rental-appraisal'

const forms = Array.from(document.querySelectorAll('.form'))
const body = document.querySelector('body')
const isProcessingClass = 'is-form-processing'

forms.forEach((form) => {
    let formData = null

    form.addEventListener('onBeforeFormieSubmit', () => {
        body.classList.add(isProcessingClass)

        // Collect FormData
        formData = new FormData(form)
    })

    form.addEventListener('onAfterFormieSubmit', (e) => {
        body.classList.remove(isProcessingClass)
        body.classList.add('is-form-submitted')

        if (form.classList.contains('js-form-rental-appraisal')) {
            postToInspectRealEstate(formData)
        }

        // Popup forms
        if (form.classList.contains('form--modal')) {
            $.magnificPopup.close()
            $('html, body').animate(
                {
                    scrollTop: 0,
                },
                800
            )
        }
    })

    form.addEventListener('onFormieSubmitError', () => {
        body.classList.remove(isProcessingClass)
    })
})
